import React from 'react'


const WizardStep = (ownProps) => {

  const { component, checklist, ...props } = ownProps

  const ref = checklist ? component() : component

  return React.createElement(ref, props)
}

export default WizardStep


// WEBPACK FOOTER //
// ./src/components/Wizard/WizardStep.js